// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal_2Lr_843zhTbroZhirZo-o3","fade-in-from-top":"styles_fade-in-from-top_1KXaZ0pHnJPYk0p0OaOEOA","fadeInFromTop":"styles_fade-in-from-top_1KXaZ0pHnJPYk0p0OaOEOA"};